
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "schoolcalendar",
components: {
InlineCalendar,XHeader
},
data(){
return{
currentterm:1,
events:[
{
depart:'计科',
event:'理论教学'
},
{
depart:'计科',
event:'理论教学'
},
],
show: true,
value: '',
listValue: '',
range: false,
showLastMonth: true,
showNextMonth: true,
highlightWeekend: true,
return6Rows: true,
hideHeader: false,
hideWeekList: false,
replaceTextList: {},
replace: false,
changeWeeksList: true,
weeksList: [],
useCustomFn: true,
buildSlotFn: () => '',
disablePast: false,
disableFuture: false,
disableWeekend: false,
disableDateFunction (date) {
if (date.formatedDate === '2017-10-16') {
return true
}
}
}
},
methods: {
onChange (val) {
console.log('on-change', val);
},
onViewChange (val, count) {

},
goHome(){
var _this= this;
_this.$router.push({name: 'home'});
},
},
watch: {
replace (val) {
this.replaceTextList = val ? {
'TODAY': '今'
} : {}
},
useCustomFn (val) {
this.buildSlotFn = val ? (line, index, data) => {
return /8/.test(data.date) ? '<div style="font-size:12px;text-align:center;"><span style="display:inline-block;width:5px;height:5px;background-color:red;border-radius:50%;"></span></div>' : '<div style="height:19px;"></div>'
} : () => ''
},
changeWeeksList (val) {
this.weeksList = val ? ['日', '一', '二', '三', '四', '五', '六 '] : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
}
},
}



// WEBPACK FOOTER //
// ./src/components/schoolcalendar.vue